import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getWorks: (state, getters, rootState, rootGetters) => {
            return state.objs.map(e => rootGetters['works/get'](e.work));
        },
        getByUser: (state) => user => {
            return state.objs.filter(e => e.user === user);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}